export default "__VITE_ASSET__C3iZx8oU__"